module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-5.4397f65b.png";